import { PropsWithChildren } from 'react'
import { useIsomorphicLayoutEffect } from 'react-use'

import Footer from '@/components/layout/Footer'
import Header from '@/components/layout/Header'
import { LenisProvider } from '@/contexts/lenis'
import useChangePathname from '@/hooks/useChangePathname'
import { useLayoutStore } from '@/store/layout'
import { useLocaleStore } from '@/store/locale'

import { WPPageData } from '@/types'

export type LayoutProps = PropsWithChildren<{ pageData: WPPageData }>

const Layout = ({ children, pageData }: LayoutProps) => {
  const setCurrentTranslations = useLocaleStore(
    (store) => store.setCurrentTranslations
  )
  const setLayoutState = useLayoutStore((state) => state.setLayoutState)

  useChangePathname()

  useIsomorphicLayoutEffect(() => {
    setCurrentTranslations(pageData.wpml_translations || [])
    setLayoutState({
      headerBackground: false
    })
  }, [pageData, setCurrentTranslations])

  return (
    <LenisProvider>
      <Header />
      <main className="min-h-svh-vh">{children}</main>
      <Footer />
    </LenisProvider>
  )
}

export default Layout
